import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

const Redirect = () => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            try {
                fetch(`redirect${window.location.search}`).then((response) => {
                    if (!response.ok) throw new Error(response.statusText);
                    return response.json();
                }).then((data) => {
                    setIsLoading(false);
                    window.location.href = '/';
                });
            } catch (error) {
                console.error('Error:', error);
                setIsLoading(false);
                window.location.href = '/';
            }
        };
        fetchData();
    }, []);


    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {isLoading ? (
                <CircularProgress size="4rem"/> // Show a loading spinner while fetching data
            ) : (
                // Render your content here
                <div>
                    <h1>Login Completed!</h1>
                </div>
            )}
        </div>
    );
};

export default Redirect;